import { env } from "env";

export const authRedirectUri =
  window.location.origin + env.REACT_APP_ROOT_PATH!;
const AUTH_B2C_MODE = "b2c";
const AUTH_AAD_MODE = "aad";
const isB2CAuthEnabled =
  // (sessionStorage.getItem("authMode")?.toLowerCase() === AUTH_B2C_MODE ||
  //   !authSearchParam) &&
  !!env.REACT_APP_AUTH_B2C_CLIENT_ID &&
  !!env.REACT_APP_AUTH_B2C_DOMAIN &&
  !!env.REACT_APP_AUTH_B2C_TENANT &&
  !!env.REACT_APP_AUTH_B2C_SCOPES;
export const authMode = isB2CAuthEnabled ? AUTH_B2C_MODE : AUTH_AAD_MODE;
